import React from "react";
import moment from "moment/moment";
import {insertParam} from "./url";

export function sortVehicles(state, vehicles, filters) {
    const {sort} = state;
    const items = [];

    vehicles.forEach((vehicle) => {
        let passedFilters = true;

        for (const key in filters) {
            const filter = filters[key];
            if (filter.hasOwnProperty("apply")) {
                // If one of the filters don't pass "apply" function
                // Fail pass
                if (!filter.apply(vehicle)) {
                    passedFilters = false;
                    break;
                }
            }
        }

        if (passedFilters) {
            items.push(vehicle);
        }
    });

    if (sort === "recent") {
        items.sort((a, b) => {
            return new moment(b["@Created"].split('.').join(""), "MM/DD/YYYY hh:mm:ss a").diff(new moment(a["@Created"].split('.').join(""), "MM/DD/YYYY hh:mm:ss a"));
        });

    }

    if (sort === "savings") {
        items.sort((a, b) => {
            if (b["@LISTING_PRICE_SPECIAL"] == 0) {
                return ((b["@LISTING_PRICE"] - b["@LISTING_PRICE"]) - (a["@LISTING_PRICE"] - a["@LISTING_PRICE_SPECIAL"]));

            } else if (a["@LISTING_PRICE_SPECIAL"] == 0) {
                return ((b["@LISTING_PRICE"] - b["@LISTING_PRICE"]) - (a["@LISTING_PRICE"] - a["@LISTING_PRICE"]));

            } else {
                return ((b["@LISTING_PRICE"] - b["@LISTING_PRICE_SPECIAL"]) - (a["@LISTING_PRICE"] - a["@LISTING_PRICE_SPECIAL"]));
            }
        });
    }

    if (sort === "lowest") {
        items
            .sort((a, b) => {
                return getSortPrice(b) - getSortPrice(a);
            })
            .reverse();
    }

    if (sort === "highest") {
        items.sort((a, b) => {
            return getSortPrice(b) - getSortPrice(a);
        });
    }

    if (sort === "new") {
        items.sort((a, b) => {
            return (
                parseInt(b["@LISTING_YEAR"]) - parseInt(a["@LISTING_YEAR"])
            );
        });
    }

    if (sort === "old") {
        items
            .sort((a, b) => {
                return (
                    parseInt(b["@LISTING_YEAR"]) -
                    parseInt(a["@LISTING_YEAR"])
                );
            })
            .reverse();
    }
    return items;
}

function getSortPrice(item) {
    const id = item["@LISTING_SEQ"];
    const isSpecial = item["@LISTING_SPECIAL"] === "True";

    const special = parseInt(item["@LISTING_PRICE_SPECIAL"]);
    const normal = parseInt(item["@LISTING_PRICE"]);
    const display = item["@LISTING_PRICE_DISPLAY"];

    let value = 0;

    if (!isNaN(special) && special > 0) {
        value = special;
    } else {
        value = normal;
    }

    if (value === 0) {
        value = normal;
    }

    return parseInt(value);
};

export function getOdometerValues(){

    const odometer = [
        { value: null, label: "Any" },
        { value: "0", label: "0k" },
        { value: "1000", label: "1k" },
        { value: "5000", label: "5k" },
        { value: "10000", label: "10k" },
        { value: "20000", label: "20k" },
        { value: "40000", label: "40k" },
        { value: "50000", label: "50k" },
        { value: "100000", label: "> 100k" },
    ];
    return odometer;
}
